"use client";

import React from "react";
import { cn } from "@/lib/utils";

interface PhoneInputProps {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  error?: string;
}

export function PhoneInput({
  id,
  value,
  onChange,
  placeholder = "0000 0000 00",
  className,
}: PhoneInputProps) {
  const formatPhoneNumber = (input: string) => {
    // Remove all non-digit characters
    const digits = input.replace(/\D/g, "");

    // Limit to 10 digits maximum
    const limitedDigits = digits.slice(0, 10);

    // Format with spaces
    if (limitedDigits.length <= 4) {
      return limitedDigits;
    } else if (limitedDigits.length <= 8) {
      return `${limitedDigits.slice(0, 4)} ${limitedDigits.slice(4)}`;
    } else {
      return `${limitedDigits.slice(0, 4)} ${limitedDigits.slice(4, 8)} ${limitedDigits.slice(8, 10)}`;
    }
  };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    // Only allow numeric input and spaces (for formatting)
    if (!/^[\d\s]*$/.test(inputValue)) {
      return; // Reject non-numeric input
    }

    const formatted = formatPhoneNumber(inputValue);
    onChange(formatted);
  };

  return (
    <input
      type="tel"
      value={value}
      onChange={handlePhoneChange}
      placeholder={placeholder}
      className={cn(
        "flex-1 bg-transparent text-auth-text-muted placeholder:text-auth-text-muted font-public-sans font-normal text-[15px] leading-[1.6] outline-none border-none p-0",
        className,
      )}
      maxLength={13}
      id={id}
    />
  );
}
